import React, { useState } from 'react';
import './Header.css';

const Header = ({ onToggleSidebar, sidebarOpen = true }) => {
  const [notificationCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleSignOut = () => {
    // Add logout logic here
    console.log('User signed out');
  };

  return (
    <nav className={`navbar navbar-static-top ${!sidebarOpen ? 'sidebar-collapsed' : ''}`} role="navigation">
      {/* Sidebar toggle button */}
      <button 
        className="sidebar-toggle" 
        onClick={onToggleSidebar}
        title="Toggle navigation"
      >
        <span className="sr-only">Toggle navigation</span>
        <span className="icon-bar"></span>
        <span className="icon-bar"></span>
        <span className="icon-bar"></span>
      </button>

      {/* Navbar Custom Menu */}
      <div className="navbar-custom-menu">
        <ul className="nav navbar-nav">
          {/* Notifications */}
          <li className="dropdown notifications-menu">
            <button
              className="dropdown-toggle notification-btn"
              onClick={() => setShowNotifications(!showNotifications)}
              title="Notifications"
            >
              <i className="fa fa-bell"></i>
              {notificationCount > 0 && (
                <sup>
                  <span className="badge badge-red">{notificationCount}</span>
                </sup>
              )}
            </button>
            {showNotifications && (
              <ul className="dropdown-menu notifications-dropdown">
                <li className="header">
                  {notificationCount > 0
                    ? `You have ${notificationCount} new notifications`
                    : 'You have no new notifications'}
                </li>
                <li className="notification-body">
                  {notificationCount === 0 ? (
                    <p className="no-notifications">No new notifications</p>
                  ) : (
                    <ul className="notification-list">
                      {/* Notifications will be added here */}
                    </ul>
                  )}
                </li>
                <li className="footer">
                  <a href="/">View all</a>
                </li>
              </ul>
            )}
          </li>

          {/* User Account Menu */}
          <li className="dropdown user user-menu">
            <button
              className="dropdown-toggle user-btn"
              onClick={() => setShowUserMenu(!showUserMenu)}
              title="User menu"
            >
              <i className="fa fa-user-circle"></i>
              <span className="user-name">Account</span>
              <i className="fa fa-angle-down"></i>
            </button>
            {showUserMenu && (
              <ul className="dropdown-menu user-dropdown">
                <li className="user-footer">
                  <button className="btn-signout" onClick={handleSignOut}>
                    <i className="fa fa-sign-out"></i> Sign Out
                  </button>
                </li>
              </ul>
            )}
          </li>
        </ul>

        {/* Company Selector */}
        <select className="company-dropdown form-control">
          <option value="">Select a company</option>
          <option value="1105">Kooheji Development</option>
          <option value="1106" selected>
            Test Kooheji Development
          </option>
        </select>
      </div>
    </nav>
  );
};

export default Header;
